<span [ngClass]="{
    'dossier-status-label': true,
    'dossier-status-label--carrier': status === 'CARRIER',
    'dossier-status-label--member': status === 'MEMBER',
    'dossier-status-label--none': status === 'NONE'
  }"><span class="status-label__text">
    <ng-content></ng-content>
  </span></span>
